import useApi from "./useApiRequest";
import { useMutation } from "react-query";

export const CrearParte = ()  => {
    const api = useApi();

    const mutate = async (params) => {
        const data  = await api.post(`/partes`, params, {
            dataType: "json",
            hasFormData: false,
            hasCustomUrl: false,
        });
        return data.data;
    };

    const mutation = useMutation(mutate);

    return {
        crearParteMutation: mutation.mutate,
    };
}